export const SELECT_ALL_OPTION_VALUE = 'Select All';
